<div class="card-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3">
        <div class="card shadow-2">
          <!-- Question Loading Container -->
          <div class="question-wrapper" id="QuestionWrapper">
            <p class="upper-text">Todos los campos son obligatorios</p>
            <div class="form-with-lbl add-data">
              <div class="row">
                <div class="col-xs-12 col-sm-6">
                  <div
                    class="form-control input-placeholder-to-label"
                    id="div_PostalCode"
                    *ngIf="getFilteredQuestion('Q5'); let question"
                  >
                    <label class="has-float-label">
                      <input
                        class="text-input inline text-09-d-demibold postal-code"
                        [class.error]="
                          isSubmitted &&
                          !validationUiService.isValidPostalCode(contractType)
                        "
                        type="tel"
                        placeholder="Código postal"
                        [(ngModel)]="postalCode"
                        maxlength="5"
                        (blur)="getCityByPostCode()"
                        (paste)="(false)"
                        id="txt_PostalCode"
                        pattern="[0-9]*"
                      />
                      <span>{{ question.QuestionText }}</span>
                    </label>
                    <p id="lblCity" style="display: none"></p>
                    <p
                      class="error-txt"
                      id="postalCodeContainer"
                      [class.hidden]="
                        !isSubmitted ||
                        (isSubmitted &&
                          validationUiService.isValidPostalCode(contractType))
                      "
                    >
                      {{ question.ErrorText }}
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6">
                  <div
                    class="form-control input-placeholder-to-label"
                    *ngIf="
                      isTelephoneQuestionEnabled && getFilteredQuestion('Q6');
                      let question
                    "
                  >
                    <label class="has-float-label">
                      <input
                        type="tel"
                        maxlength="9"
                        (keyup)="onKeyPress($event)"
                        (keypress)="onKeyPress($event)"
                        (ngModelChange)="onTeleModelChange($event)"
                        name="txt_Phone"
                        id="txt_Phone"
                        autocomplete="off"
                        class="text-input inline text-09-d-demibold"
                        [class.error]="
                          isSubmitted &&
                          !validationUiService.isValidTelephone(
                            contractType.phone
                          )
                        "
                        (paste)="(false)"
                        [pattern]="
                          !applyTeleMask().isMaskedApplied
                            ? '(6|7|8|9)\\d{8}'
                            : ''
                        "
                        [ngModel]="applyTeleMask().transformedData"
                        placeholder="Teléfono"
                      />
                      <span> {{ question.QuestionText }} </span>
                    </label>
                    <span
                      [class.hidden]="!isPrefilledPhone"
                      id="prefilledPhone"
                      style=""
                      class="sub-title"
                      >Utilizaste éste en la anterior comparativa. Si quieres,
                      puedes cambiarlo</span
                    >
                    <p
                      class="error-txt"
                      id="telephoneContainer"
                      [class.hidden]="
                        !isSubmitted ||
                        (isSubmitted &&
                          validationUiService.isValidTelephone(
                            contractType.phone
                          ))
                      "
                    >
                      {{ question.ErrorText }}
                    </p>
                  </div>

                  <div
                    class="form-control input-placeholder-to-label email-q"
                    id="divEmail"
                    *ngIf="
                      !isTelephoneQuestionEnabled && getFilteredQuestion('Q7');
                      let question
                    "
                  >
                    <label class="has-float-label">
                      <input
                        type="email"
                        id="txt_EmailAddress"
                        [ngModel]="applyEmailMask()"
                        (ngModelChange)="onEmailModelChange($event)"
                        (input)="isValidEmail(contractType.emailAddress)"
                        class="text-input text-09-d-demibold"
                        [class.error]="
                          isSubmitted &&
                          !validationUiService.isValidEmail(
                            contractType.emailAddress
                          )
                        "
                        maxlength="255"
                        autocomplete="off"
                        placeholder="Email"
                        (paste)="(false)"
                      />
                      <span> {{ question.QuestionText }}</span>
                    </label>
                    <p
                      class="error-txt"
                      style="display: block"
                      [class.hidden]="
                        !isSubmitted ||
                        (isSubmitted &&
                          validationUiService.isValidEmail(
                            contractType.emailAddress
                          ))
                      "
                      id="emailContainer"
                    >
                      {{ question.ErrorText }}
                    </p>
                    <span
                      *ngIf="isPrefilledEmail"
                      id="prefilledEmail"
                      style=""
                      class="sub-title"
                      >Utilizaste éste en la anterior comparativa. Si quieres,
                      puedes cambiarlo</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-control input-placeholder-to-label email-q"
              id="divEmail"
              *ngIf="
                isTelephoneQuestionEnabled && getFilteredQuestion('Q7');
                let question
              "
            >
              <label class="has-float-label">
                <input
                  type="email"
                  id="txt_EmailAddress"
                  [ngModel]="applyEmailMask()"
                  (ngModelChange)="onEmailModelChange($event)"
                  (input)="isValidEmail(contractType.emailAddress)"
                  class="text-input text-09-d-demibold"
                  [class.error]="
                    isSubmitted &&
                    !validationUiService.isValidEmail(contractType.emailAddress)
                  "
                  maxlength="255"
                  autocomplete="off"
                  placeholder="Email"
                  (paste)="(false)"
                />
                <span> {{ question.QuestionText }}</span>
              </label>
              <p
                class="error-txt"
                style="display: block"
                [class.hidden]="
                  !isSubmitted ||
                  (isSubmitted &&
                    validationUiService.isValidEmail(contractType.emailAddress))
                "
                id="emailContainer"
              >
                {{ question.ErrorText }}
              </p>
              <span
                *ngIf="isPrefilledEmail"
                id="prefilledEmail"
                style=""
                class="sub-title"
                >Utilizaste éste en la anterior comparativa. Si quieres, puedes
                cambiarlo</span
              >
            </div>
            <div class="form-control normal-checkbox" id="policyCheckBoxDiv">
              <label
                class="normal-checkbox-container"
                [class.error]="isSubmitted && !isCheckBox"
                id="label_EmailAddress"
              >
                <input
                  type="checkbox"
                  [(ngModel)]="isCheckBox"
                  name="checkBox_EmailAddress"
                  id="checkBox_EmailAddress"
                />
                <div class="checkmark-container" id="divPolitica">
                  <span class="checkmark"></span>
                  <span class="text-09-m-regular text-13-d-regular">
                    He leído y acepto el
                    <a
                      href="https://www.rastreator.com/aviso-legal.aspx"
                      target="_blank"
                      class="white-bg"
                      >Aviso Legal</a
                    >,
                    <a
                      href="https://www.rastreator.com/doc/informacion-previa-del-mediador.pdf"
                      target="_blank"
                      >Info Previa</a
                    >
                    y la
                    <a
                      href="https://www.rastreator.com/politica-de-privacidad.aspx"
                      target="blank"
                      class="white-bg"
                      >Política de Privacidad,</a
                    >
                    y reconozco que la información legal previa está disponible
                    en la Web.
                  </span>
                </div>
                <div class="email-legal-text">
                  <p>
                    También puedes recibir esta información en papel,
                    contactando con nosotros en clientes@rastreator.com
                  </p>
                </div>
                <div class="phone-legal-text">
                  <p>Para ayudarte es posible que te contactemos por teléfono de lunes a viernes de 9:00 a 20:30h y sábados de 9:00 a 15:00h.</p>
                </div>
                <p
                  [class.error]="isSubmitted && !isCheckBox"
                  id="errorPolitica"
                >
                  Por favor, acepta el Aviso Legal, Info Previa, la Política de
                  Privacidad y reconoce que la información legal previa está
                  disponible en la Web.
                </p>
              </label>
            </div>
            <p class="error" id="errorContainer"></p>
          </div>

          <!-- Questions Submit Buttons (Next & Previous) -->
          <div id="options-wrapper" class="options-wrapper">
            <a
              href="javascript:void(0)"
              id="prev"
              class="btn rounded prev"
              style="visibility: visible"
              (click)="prev()"
            >
              <i class="icon icon-chevron-left"></i>
            </a>
            <a
              href="javascript:void(0)"
              id="next"
              class="btn solid-main next text-08-d-regular"
              (click)="saveAnswer()"
              style=""
              >VER OFERTAS</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
